
import { defineComponent, PropType } from "vue";
import SvgIcon from "@jamescoyle/vue-icon";
import { mdiChevronRight, mdiChevronLeft } from "@mdi/js";
import { Pagination } from "@/types/Pagination";
import { Link as InertiaLink } from "@inertiajs/inertia-vue3";

export default defineComponent({
  components: {
    SvgIcon,
    InertiaLink,
  },
  props: {
    paginate: Object as PropType<Pagination<any>>,
    size: {
      type: String,
      default: () => "sm",
    },
    only: {
      type: Object as PropType<String[]>,
      default: () => [],
    },
    preserveScroll: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      rightIcon: mdiChevronRight,
      leftIcon: mdiChevronLeft,
    };
  },
  computed: {
    rawLinks(): any {
      return (this as any).paginate?.links.filter(
        (link: any) => link.label !== "..."
      );
    },
    currentPage(): any {
      return (this as any).paginate?.current_page;
    },
    lastPage(): any {
      return (this as any).paginate?.last_page;
    },
    perPage(): any {
      return (this as any).paginate?.per_page;
    },
    hasMorePages(): any {
      return (this as any).paginate?.total > this.perPage;
    },
    onEachSide(): number {
      switch (this.size) {
        case "sm":
          return 0;
        case "md":
          return 1;
        case "lg":
          return 6;
      }

      return 0;
    },
    linksBeforeCurrent() {
      const links: any = this.rawLinks;
      const currentPageIndex: any = links.findIndex(
        (link: any) => link.label == this.currentPage
      );

      const before: any = [];
      const beforeStartIndex: any = currentPageIndex - this.onEachSide;

      if (beforeStartIndex > 1 && this.onEachSide > 0) {
        before.push(links[1]);
        before.push({
          url: null,
          label: "...",
        });
      }

      before.push(
        ...links.slice(
          beforeStartIndex > 1 ? beforeStartIndex : 1,
          currentPageIndex
        )
      );

      return before;
    },
    linksAfterCurrent() {
      const links: any = this.rawLinks;
      const currentPageIndex: any = links.findIndex(
        (link: any) => link.label == this.currentPage
      );

      const after: any = [];
      const afterEndIndex: any = currentPageIndex + this.onEachSide + 1;

      after.push(
        ...links.slice(
          currentPageIndex + 1,
          afterEndIndex < links.length ? afterEndIndex : links.length - 1
        )
      );

      if (this.onEachSide > 0) {
        if (afterEndIndex < links.length - 2) {
          after.push({
            url: null,
            label: "...",
          });
        }

        if (afterEndIndex < links.length - 1) {
          after.push(links[links.length - 2]);
        }
      }

      return after;
    },
    links() {
      const links: any = this.rawLinks;
      if (!links) {
        return [];
      }

      let visibleLinks: any = [];

      visibleLinks.push(links[0]);

      visibleLinks.push(...this.linksBeforeCurrent);
      visibleLinks.push(
        links.find((link: any) => link.label == this.currentPage)
      );
      visibleLinks.push(...this.linksAfterCurrent);

      visibleLinks.push(links[links.length - 1]);

      return visibleLinks;
    },
  },
  methods: {
    goToPage(link: any) {
      return (this as any).$inertia.get(link.url, {
        page: link.label,
        preserveState: true,
        replace: true,
        preserveScroll: this.preserveScroll,
      });
    },
    getItemClasses(link: any) {
      if (link.active) {
        return "active";
      }

      if (link.url) {
        return "link";
      }
    },
  },
});
